import React, { useEffect, useState } from 'react'
import { BackButton, CancelButton, SubmitButton } from '../../../../Components/Utils/Buttons';
import { NuDate, NuInput } from '../../../../Components/Utils/Input';
import FormikSelectTwo from '../../../../Components/Utils/Select';
import { useFormik } from 'formik';
import useEditFormData from '../../../../Components/Hooks/useEditFormData';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import * as yup from 'yup';
import MultiSelect, { MultiSelectinp } from '../../../../Components/Utils/MultiSelect';
import { useToast } from '../../../../Components/Others/ToastServices';
import Attachement, { videotype } from '../../../../Components/Utils/CustomAttrachmentupload';
import CloseIcon from '../../../../Components/Icons/Close';
import Doc from '../../../../Components/Icons/Doc';
import Xls from '../../../../Components/Icons/Xls';
import Txt from '../../../../Components/Icons/Txt';
import Pdf from '../../../../Components/Icons/Pdf';
import Video from '../../../../Components/Icons/Video';
import UseDropDown from '../../../../Components/Hooks/useDropDown';
import useFetchMataData from '../../../../Components/Hooks/useFetchMataData';
import DropDownAddMetaData from '../../../../Components/Utils/selectAddMetaData';
import Breadcrumb from '../../../../Components/Utils/Breadcrumb';
import axiosInstance from '../../../../Services/axiosCommon';
import { SettingHeading } from '../../../../Components/Utils/Settingheading';
import UseDropDownNew from '../../../../Components/Hooks/useDropDownNew';
import Select from 'react-select';

function EditSchedule() {
  const { scheduleEditId } = useParams();
  // const { data: form } = UseDropDownNew(`/form/drop-down`);
  const navigate = useNavigate();
  const location = useLocation();
  const [data, setData] = useState(null);
  const [createNew, setCreateNew] = useState([]);
  const [formAssignees, setFormAssignees] = useState([]);

  function getView() {
    axiosInstance
      .get(`/schedules/${scheduleEditId}`)
      .then((res) => {
        const scheduleData = res?.data?.data;
        setData(scheduleData);
        
        setCreateNew({
          contractId: scheduleData?.contractId || "",
          location: scheduleData?.location || "",
          description: scheduleData?.description || "",
          date: scheduleData?.date || "",
          refNumber: scheduleData?.refNumber || "",
          locationMap: scheduleData?.locationMap || "",
          googleCoordinates: scheduleData?.googleCoordinates || "",
          status: scheduleData?.status || "",
          assignees: scheduleData?.assignees?.map(item => Number(item.assignee)) || [],
          filesToRemove: [],
          forms: []
        });

           if (scheduleData?.forms) {
          setFormAssignees(
            scheduleData.forms.map(formItem => ({
              formId: formItem.formId,
              formName: formItem.formName,
              assignees: formItem.assignees?.map(assignee => assignee.assignee) || [],
              id:formItem.id
            }))
          );
        }
      })
      .catch(err => {
        console.log("err", err);
      })
  }

  useEffect(() => {
    getView();
  }, [])

  const { value: inspectionType, getData: refinspectionType } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "Inspection_Type_Contracts"
  );
  const { value: scheduleType, getData: refscheduleType } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "Schedule_Type_Schedule"
  );
  const { value: status, getData: refstatus } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "Status_Schedule"
  );

  const { data: user } = UseDropDown(`/user/team-drop-down`);
  const [Newinspector, setInspector] = useState([]);

  function getContractsByClientId() {
    axiosInstance
      .get(`/team/drop-down`)
      .then((res) => {
        if (Array.isArray(res.data)) {
          const formatted = res.data.map(item => ({
            value: item.value,
            label: item.label,
          }));
          setInspector(formatted);
        } else {
          console.error("Unexpected API response format");
          setInspector([]);
        }
      })
      .catch(err => {
        console.error("Error fetching contracts by client ID:", err);
        setInspector([]);
      });
  }

  useEffect(() => {
    getContractsByClientId()
  }, [])

  const { data: contract } = UseDropDown(`/contract/drop-down`);
  const from = location.state?.from;
  const { editFormData, isLoading } = useEditFormData();

  const [filePathList, setFilePathList] = useState([]);
  const [fileRemoveList, setFileRemoveList] = useState([]);
  const [image, setImage] = useState([]);
  const toast = useToast();
  const [removefilePathList, setRemoveFilePathList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [fileExtention, setFileExtention] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);

  function handleImageChange(e) {
    const maxFileSize = 200000000; // 200 MB
    const files = Array.from(e.target.files);
    let fileArr = [];

    files.forEach((item) => {
      if (item.size < maxFileSize) {  
        fileArr.push(item);
      } else {
        toast.open({
          type: "warning",
          message: `File Size too big`,
          description: `${item.name} is removed and not uploaded`,
        });
      }
    });

    setSelectedFile(fileArr);


    setImage(fileArr);
    e.target.value = null;
  }

  const removeImages = (value) => {
    let List = selectedFile.filter((item) => item?.name !== value?.name);
    setSelectedFile([...List]);
    setImage(List);
  };

  useEffect(() => {
    if (
      data?.attachments !== null &&
      data?.attachments !== "None" &&
      data?.attachments !== "[]"
    ) {
      setFilePathList(data?.attachments);
      setRemoveFilePathList(data?.attachments || []);
    }
  }, [data]);

  function UpdateAttachmentList(item) {
    let filterList = filePathList.filter((itemList) => itemList.file !== item);
    let removeFile = filePathList.find((itemList) => itemList.file === item);
    setFileRemoveList([...fileRemoveList, removeFile.file]);
    setFilePathList(filterList);
  }

  function handleImageClick(img) {
    let Ext = img?.file_name.split(".").reverse()[0];
    setSelectedImage(img);
    setFileExtention(Ext);
    setIsModalOpen(true);
  }

 

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      contractId: yup.string().required("Contract is required!"),
    }),
    onSubmit: async (value, { resetForm }) => {
      let formData = new FormData();
      const valueWithItems = {
        ...value,
        forms: formAssignees.map(form => ({
          formId: form.formId,
          assignees: form.assignees,
          id: form.id,

        })),
        filesToRemove: fileRemoveList,
      };
      formData.append("json_data", JSON.stringify(valueWithItems));
      if (selectedFile !== null) {
        selectedFile.forEach((file) => {
          formData.append("attachments", file);
        });
      } else {
        formData.append("attachments", []);
      }
      await editFormData({
        url: `/schedules/edit-schedule/${scheduleEditId}`,
        formData: formData,
        navigateUrl: from || `/inspection/schedule`,
        resetForm: resetForm
      })
    },
  });

  const handleAssigneeChange = (formId, selectedOptions) => {
    setFormAssignees(prev => prev.map(form => {
      if (form.formId === formId) {
        return {
          ...form,
          assignees: selectedOptions.map(option => option.value)
        };
      }
      return form;
    }));
  };

  return (
    <div className=" w-full h-full py-2 px-4 ">
      <div className="flex justify-between w-full ">
        <Breadcrumb
          items={[
            {
              name: "Schedule",
              link: "/inspection/schedule"
            },
            { name: "Edit" },
          ]}
        />
        <BackButton />
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className="w-full mx-auto h-[calc(100vh-145px)] bg-white rounded-xl overflow-hidden mt-4">
          <div className=" w-full h-full flex justify-start content-start flex-wrap py-2 px-4  overflow-y-auto">
            <div className="w-full">
              <SettingHeading title={`Inspection Schedule : ${createNew?.refNumber}`} />
            </div>

            <NuInput
              type="text"
              label="Description"
              placeholder="Description"
              formik={formik}
              name="description"
              width="w-full md:w-1/2 lg:w-2/3 "
            />

            <FormikSelectTwo
              label="Contract "
              Options={contract}
              formik={formik}
              placeholder="Choose"
              name="contractId"
              isRequired={true}
              disabled={true}
              width="w-full md:w-1/2 lg:w-1/3"
            />

            <NuInput
              type="text"
              label="Location"
              placeholder="Location"
              formik={formik}
              name="location"
              width="w-full md:w-1/3"
            />

            <NuDate
              label="Date"
              placeholder="Date"
              formik={formik}
              name="date"
              width="w-full md:w-1/3 "
            />

            <NuInput
              type="text"
              label="Location Map"
              placeholder="Location Map"
              formik={formik}
              name="locationMap"
              width="w-full md:w-1/2 lg:w-1/3"
            />
            <NuInput
              type="text"
              label="Google Coordinates"
              placeholder="Google Coordinates"
              formik={formik}
              name="googleCoordinates"
              width="w-full md:w-1/2 lg:w-1/3"
            />

            <DropDownAddMetaData
              label="Status"
              placeholder="Choose"
              Options={status}
              formik={formik}
              name="status"
              width="w-full md:w-1/3 md:-mt-1 "
              getFunc={refstatus}
              displayProperty={"Status"}
              propertyName={"Status_Schedule"}
              FixPosition={false}
              PortalTarget={false}
            />

            <div className="w-full">
              <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
                Attachement
              </p>
              <Attachement
                handleChange={handleImageChange}
                preview={image || ""}
                width="w-full"
                label="Attach"
                multiple={true}
                removeImages={removeImages}
              />
            </div>
            <div className="md:flex justify-between mt-5 px-3 w-full">
              <div className="w-full flex gap-2 items-center flex-wrap">
                {filePathList &&
                  filePathList?.map((imgs, idx) => {
                    let Ext = imgs?.file_name.split(".").reverse()[0];
                    return (
                      <div
                        className=" w-20 h-9 my-2 relative flex justify-center items-center rounded-lg"
                        key={idx}
                        style={{
                          border: "1px solid gray",
                          borderColor: "rgb(148 163 184 / var(--tw-bg-opacity))",
                        }}
                      >
                        <div
                          className=" w-4 h-4 rounded bg-slate-400 absolute text-white cursor-pointer font-medium flex justify-center items-center  -top-2 -right-2 z-10"
                          onClick={() => UpdateAttachmentList(imgs?.file)}
                        >
                          <CloseIcon color="white" height="8" width="8" />
                        </div>
                        <div
                          className=" w-20 h-9 flex justify-center items-center rounded-lg overflow-hidden cursor-pointer"
                          onClick={() => handleImageClick(imgs)}
                        >
                          <div className=" w-8 h-8">
                            {videotype.includes(Ext) ? <Video /> : null}
                            {Ext === ("docx" || "doc" || "txt") ? (
                              <Doc />
                            ) : Ext === ("xlsx" || "xls") ? (
                              <Xls />
                            ) : Ext === "txt" ? (
                              <Txt />
                            ) : Ext === "pdf" ? (
                              <Pdf />
                            ) : Ext === "PDF" ? (
                              <Pdf />
                            ) : Ext === "pptx" ? (
                              <>No file</>
                            ) : (
                              <img src={imgs?.file} alt="#" width="120%" />
                            )}
                          </div>
                          <p className=" w-[50px] text-[11px] truncate">
                            {imgs?.file_name}
                          </p>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>

            <div className="w-full h-full flex flex-wrap mb-4">
              <div className="w-full">
                <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
                  Form :
                </p>
              </div>

              <div className="w-full py-3 bg-baseColor-primary rounded-lg px-6 hidden md:flex ">
                <p className="w-[5%] text-left text-white text-xs font-medium">S.No</p>
                <p className="w-[55%] text-left text-white text-xs font-medium">Form</p>
                <p className="w-[40%] text-center text-white text-xs font-medium">Assignees</p>
              </div>

              <div className="h-[calc(100vh-300px)] overflow-y-auto w-full">
                {data?.forms?.length > 0 ? (
                  data.forms.map((item, idx) => (
                    <div
                      key={item.formId}
                      className="w-full  px-4 sm:px-6 border sm:flex sm:justify-between sm:items-center odd:bg-white even:bg-slate-50"
                    >
                      <p className="md:w-[5%] w-auto text-left text-xs font-medium text-[#111537]">
                        {idx + 1}
                      </p>

                      <p className="md:w-[55%] w-auto text-left text-xs font-medium text-[#111537]">
                        {item.formName}
                      </p>

                      <div className="md:w-[40%] w-auto text-left text-xs font-medium text-[#111537]">
                        <MultiSelectinp
                          label="Assignee"
                          Options={Newinspector}
                          value={formAssignees.find(f => f.formId === item.formId)?.assignees?.map(assignee => ({
                            value: assignee,
                            label: Newinspector.find(i => i.value === assignee)?.label || assignee
                          })) || []}
                          onChange={(selectedOptions) => handleAssigneeChange(item.formId, selectedOptions)}
                          placeholder="Choose"
                          width="w-full"
                        />
                      </div>
                    </div>
                  ))
                ) : (
                  <p className="text-xs text-gray-500 p-6">No forms available.</p>
                )}
              </div>
            </div>

            <div className="w-full  my-4 mt-8 ">
              <div className=" flex justify-end gap-4">
                <CancelButton
                  handleClick={() => {
                    navigate(-1);
                  }}
                />
                <SubmitButton isLoading={isLoading} />
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default EditSchedule;

